import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const userSetting = createApi({
    reducerPath: 'userSetting',
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['GeneralSettings', 'masjidInformation'],
    endpoints: (builder) => ({

        getGeneralSettings: builder.query({
            query: () => ({
                url: `/api/general-settings/get-general-settings`,
                method: 'GET',
            }),
            providesTags: ['GeneralSettings'],
        }),

        updateGeneralSettings: builder.mutation({
            query: (data) => ({
                url: `/api/general-settings/update-general-settings`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['GeneralSettings'],
        }),


        // MASJID INFORMATION
        getMasjidInformation: builder.query({
            query: () => ({
                url: `/api/masjid/info`,
                method: 'GET',
            }),
            providesTags: ['masjidInformation'],
        }),

        updateMasjidInformation: builder.mutation({
            query: ({ transformedData }) => ({
                url: `/api/masjid/update-info`,
                method: 'POST',
                body: transformedData,
            }),
            // The time zone shown in General Settings comes from the location.
            invalidatesTags: ['masjidInformation', 'GeneralSettings'],
        }),

    }),
});

export const {
    useGetGeneralSettingsQuery,
    useUpdateGeneralSettingsMutation,
    useGetMasjidInformationQuery,
    useUpdateMasjidInformationMutation
} = userSetting;
